import React from "react";
import { motion } from "framer-motion";
import { Star, Zap, Building2 } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const ICONS = [Star, Zap, Building2];

export const Strengths = () => {
  const { t } = useLanguage();
  return (
    <section id="strengths" data-testid="strengths-section" className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-3xl"
        >
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-cyan-600" data-testid="strengths-eyebrow">
            {t.strengths.eyebrow}
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">
            {t.strengths.title}
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">{t.strengths.subtitle}</p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-slate-200 border border-slate-200">
          {t.strengths.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.65, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
                className="bg-white p-8 lg:p-10 group hover:bg-slate-50 hover:-translate-y-1 transition-all duration-300"
                data-testid={`strength-card-${i}`}
              >
                <div className="w-14 h-14 flex items-center justify-center bg-[#0F172A] text-cyan-400 group-hover:bg-cyan-500 group-hover:text-white transition-colors duration-300">
                  <Icon size={26} strokeWidth={1.75} />
                </div>
                <h3 className="mt-6 font-display text-xl lg:text-2xl font-bold text-slate-900">{item.title}</h3>
                <p className="mt-3 text-sm sm:text-base text-slate-600 leading-relaxed">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
